import { faBan } from '@fortawesome/duotone-regular-svg-icons';
import { Link } from '@mui/material';
import { useSearchParams } from 'react-router';

import {
  Description as StatusMessageDescription,
  Root as StatusMessageRoot,
} from '../components/StatusMessage.tsx';
import { config } from '../config.ts';

export function Unauthorized() {
  const [searchParams] = useSearchParams();

  if (searchParams.get('reason') === 'expired-link') {
    return (
      <StatusMessageRoot
        title="Link expired"
        description={
          <StatusMessageDescription>
            This link has expired or has already been used. Please sign in to{' '}
            <Link href={config.PORTAL_BASE_URL} target="_blank">
              Mend
            </Link>{' '}
            to continue.
          </StatusMessageDescription>
        }
        faIcon={faBan}
      />
    );
  }

  return (
    <StatusMessageRoot
      title="Access not authorized"
      description="You don't have permission to access Signal. Please contact your
        organization administrator to request access."
      faIcon={faBan}
    />
  );
}
